<template>
  <div id="app" :class="`cmg-page ${lang}`">
    <div id="cmg-swiper" class="cmg-swiper cmg-box">
      <div class="swiper">
        <div class="swiper-wrapper">
          <!-- 欢迎页 -->
          <div class="swiper-slide swiper-no-swiping">
            <div class="content content1">
              <div class="main">
                <div class="logo">
                  <div class="snow">
                    <img src="./assets/snow1.png" alt="" />
                  </div>
                  <div class="cmg">
                    <img src="./assets/logo1.png" alt="2022北京冬奥" />
                  </div>
                </div>
                <div class="title">
                  <h3>2022北京冬奥<br />媒体技术创新应用</h3>
                  <h5>Innovative application of CMG <br />media technology in Beijing 2022 <br />Olympic Winter Games</h5>
                </div>
              </div>
              <div class="lang swiper-no-swiping">
                <span class="zh" @click="chooseLang('zh')">中文</span>
                <span class="en" @click="chooseLang('en')">English</span>
              </div>
            </div>
          </div>
          <!-- 宣传视频 -->
          <div class="swiper-slide">
            <div class="content content2">
              <div class="snow"></div>
              <div class="logo">
                <img src="./assets/logo2.png" alt="2022北京冬奥" />
              </div>
              <div class="title">
                <h3>2022北京冬奥媒体技术创新应用</h3>
                <h5>Innovative application of CMG media technology in Beijing 2022 Olympic Winter Games</h5>
              </div>
              <div class="main">
                <div class="video-box swiper-no-swiping" id="video-publicity">
                  <div class="video-cover">
                    <img :src="require('./assets/publicity-poster-0126.jpg')" />
                    <div class="play" @click="createVideo('publicity-v', pid0)"></div>
                  </div>
                  <div class="video-long" id="publicity-v"></div>
                </div>

                <div class="brief swiper-no-swiping">
                  <div class="inner" v-html="DATA.publicity.brief[lang]"></div>
                </div>
                <div class="prev" @click="slideTo(0)">
                  <span></span>
                </div>
                <div class="next" @click="slideTo(2)">
                  <span></span>
                </div>
              </div>
            </div>
          </div>
          <!-- 主导航 -->
          <div class="swiper-slide">
            <div class="content content3">
              <div class="snow"></div>
              <div class="logo">
                <img src="./assets/logo2.png" alt="2022北京冬奥" />
              </div>
              <div class="title">
                <h3>2022北京冬奥媒体技术创新应用</h3>
                <h5>Innovative application of CMG media technology in Beijing 2022 Olympic Winter Games</h5>
              </div>
              <div class="prev" @click="slideTo(1)">
                <span></span>
              </div>
              <div class="menu">
                <div class="menu-item" v-for="(menu, index) in DATA.scene" :key="index" @click="showScene(index + 1)">
                  <div class="num">{{ menu.id }}</div>
                  <div class="name" v-html="menu.name[lang]"></div>

                  <!-- <div class="icon" v-lazy-container="{ selector: 'img' }">
                    <img :data-src="`${publicPath}img/scene${index + 1}/icon-scene${index + 1}.jpg`" src="./assets/blank.png" />
                  </div> -->
                  <div class="icon">
                    <img :src="require(`./assets/icon-scene${index + 1}.jpg`)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 场景 -->
    <div class="cmg-scene cmg-box">
      <div class="scene-flex">
        <!-- 当前场景名称 -->
        <div class="scene-name">
          <span v-show="lang == 'zh'" class="label" v-html="DATA.scene[sceneID - 1].name[lang]"></span>
          <span v-show="lang == 'en'" class="label" v-lazy-container="{ selector: 'img' }">
            <img :data-src="`${publicPath}${DATA.scene[sceneID - 1].name.pic}`" src="./assets/blank.png" />
          </span>
          <span class="back" @click="hideScene"></span>
        </div>

        <!-- 场景1 -->
        <div class="scene-box scene1" v-show="sceneID === 1" @scroll="stopVideo($event)">
          <div class="scroll">
            <div class="brief">
              <div class="num" v-html="DATA.scene[0].id"></div>
              <div class="inner" v-html="DATA.scene[0].brief[lang]"></div>
            </div>

            <div class="title title1">
              <span v-html="DATA.scene[0].title1[lang]"></span>
            </div>

            <!-- 转播车 -->
            <div class="video-box">
              <div class="video-cover" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene1/poster1_1.jpg${version}`" src="./assets/blank.png" />
                <div class="play" @click="createVideo('scene1-v1', pid1_1)"></div>
              </div>
              <div class="video-16-9" id="scene1-v1"></div>
            </div>

            <!-- 8k超高清转播车 -->
            <div class="pic pic2" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene1/scene1-2.png${version}`" src="./assets/blank.png" />
            </div>

            <div class="info info2">
              <h5 v-html="DATA.scene[0].head2[lang]"></h5>
              <p v-html="DATA.scene[0].body2[lang]"></p>
              <div class="btn">
                <div class="btn-vr">
                  <div class="vr" @click="showCarVR">
                    <div class="inner"></div>
                  </div>
                  <span v-html="DATA.vr[lang]"></span>
                </div>
                <div class="btn-view">
                  <div class="view" @click="showCarIntro">
                    <div class="inner"></div>
                  </div>
                  <span v-html="DATA.detail[lang]"></span>
                </div>
              </div>
            </div>

            <div class="pic pic3" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene1/scene1-3.jpg${version}`" src="./assets/blank.png" />
            </div>

            <div class="info info3">
              <div class="grey">
                <h5 v-html="DATA.scene[0].head3[lang]"></h5>
                <p v-html="DATA.scene[0].body3[lang]"></p>
              </div>

              <div class="grey-r">
                <h5 v-html="DATA.scene[0].head4[lang]"></h5>
                <p v-html="DATA.scene[0].body4[lang]"></p>
              </div>
            </div>

            <div class="pic pic4" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene1/scene1-4.jpg${version}`" src="./assets/blank.png" />
            </div>

            <!-- 4k超高速轨道摄像机 -->
            <div class="video-box">
              <div class="video-cover" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene1/poster1_2.jpg${version}`" src="./assets/blank.png" />
                <div class="play" @click="createVideo('scene1-v2', pid1_2)"></div>
              </div>
              <div class="video-16-9" id="scene1-v2"></div>
            </div>

            <div class="pic pic1" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene1/scene1-1.png${version}`" src="./assets/blank.png" />
            </div>

            <div class="info info1">
              <h5 v-html="DATA.scene[0].head1[lang]"></h5>
              <p v-html="DATA.scene[0].body1[lang]"></p>
            </div>

            <!-- 闭幕  -->
            <div class="info closing" v-if="lang == 'zh'">
                <div class="video-box">
                    <div class="video-cover" v-lazy-container="{ selector: 'img' }">
                      <img :data-src="`${publicPath}img/scene1/poster1_closing.jpg${version}`" src="./assets/blank.png" />
                      <div class="play" @click="createVideo('scene1-closing', pid1_closing)"></div>
                    </div>
                    <div class="video-16-9" id="scene1-closing"></div>
                </div>

                <div class="closing-gif">
                   <div class="gif-image"><img src="https://static.qr.cctv.com/dongao4K/image/con02_page04_gif1.gif?v=20220408" alt=""></div>
                   <div class="gif-image"><img src="https://static.qr.cctv.com/dongao4K/image/con02_page04_gif2.gif?v=20220408" alt=""></div>
                </div>

              <div class="info closing-info">
                <h5 v-html="DATA.scene[0].headClosing[lang]"></h5>
                <p v-html="DATA.scene[0].bodyClosing[lang]"></p>
              </div>
            </div>

             

            <div class="title title2" v-html="DATA.scene[0].title2[lang]"></div>

            <div class="intro-box">
              <div class="intro intro1">
                <div class="cover" v-lazy-container="{ selector: 'img' }">
                  <img :data-src="`${publicPath}img/scene1/scene1-5.jpg${version}`" src="./assets/blank.png" />
                </div>
                <h5 v-html="DATA.scene[0].head5[lang]"></h5>
                <p v-html="DATA.scene[0].body5[lang]"></p>
              </div>

              <div class="intro intro2">
                <div class="cover" v-lazy-container="{ selector: 'img' }">
                  <img :data-src="`${publicPath}img/scene1/scene1-6.jpg${version}`" src="./assets/blank.png" />
                </div>
                <h5 v-html="DATA.scene[0].head6[lang]"></h5>
                <p v-html="DATA.scene[0].body6[lang]"></p>
              </div>

              <div class="intro intro3">
                <div class="cover" v-lazy-container="{ selector: 'img' }">
                  <img :data-src="`${publicPath}img/scene1/scene1-7.jpg${version}`" src="./assets/blank.png" />
                </div>
                <h5 v-html="DATA.scene[0].head7[lang]"></h5>
                <p v-html="DATA.scene[0].body7[lang]"></p>
              </div>

              <div class="intro intro4">
                <div class="cover" v-lazy-container="{ selector: 'img' }">
                  <img :data-src="`${publicPath}img/scene1/scene1-8.jpg${version}`" src="./assets/blank.png" />
                </div>
                <h5 v-html="DATA.scene[0].head8[lang]"></h5>
                <p v-html="DATA.scene[0].body8[lang]"></p>
              </div>

              <div class="intro intro5">
                <div class="cover" v-lazy-container="{ selector: 'img' }">
                  <img :data-src="`${publicPath}img/scene1/scene1-12.jpg${version}`" src="./assets/blank.png" />
                </div>
                <h5 v-html="DATA.scene[0].head9[lang]"></h5>
                <p v-html="DATA.scene[0].body9[lang]"></p>
              </div>
            </div>

            <section class="continue-box" @click="nextScene()">
              <div class="continue"></div>
            </section>
          </div>
        </div>

        <!-- 场景2 -->
        <div class="scene-box scene2" v-show="sceneID === 2" @scroll="stopVideo($event)">
          <div class="scroll">
            <div class="brief">
              <div class="num">{{ DATA.scene[1].id }}</div>
              <div class="inner">{{ DATA.scene[1].brief[lang] }}</div>
            </div>
            <!-- 8K制播  -->
            <div class="video-box">
              <div class="video-cover" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene2/poster2_1.jpg${version}`" src="./assets/blank.png" />
                <div class="play" @click="createVideo('scene2-v1', pid2_1)"></div>
              </div>
              <div class="video-16-9" id="scene2-v1"></div>
            </div>

            <div class="pic pic1" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene2/scene2-1.jpg${version}`" src="./assets/blank.png" />
            </div>
            <div class="info info1">
              <h5>{{ DATA.scene[1].head1[lang] }}</h5>
              <p v-html="DATA.scene[1].body1[lang]"></p>
              <div class="btn-view" @click="showPopupIntro(DATA.popup2_1)">
                <div class="view">
                  <div class="inner"></div>
                </div>
                <span v-html="DATA.detail[lang]"></span>
              </div>
            </div>

            <div class="pic pic2" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene2/scene2-2.jpg${version}`" src="./assets/blank.png" />
            </div>
            <div class="info info2">
              <h5>{{ DATA.scene[1].head2[lang] }}</h5>
              <p v-html="DATA.scene[1].body2[lang]"></p>
              <div class="btn-view" @click="showPopupIntro(DATA.popup2_2)">
                <div class="view">
                  <div class="inner"></div>
                </div>
                <span v-html="DATA.detail[lang]"></span>
              </div>
            </div>

            <div class="pic pic3 full" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene2/scene2-3.png${version}`" src="./assets/blank.png" />
            </div>
            <div class="info info3">
              <h5>{{ DATA.scene[1].head3[lang] }}</h5>
              <p v-html="DATA.scene[1].body3[lang]"></p>
              <div class="btn-view" @click="showPopupIntro(DATA.popup2_3)">
                <div class="view">
                  <div class="inner"></div>
                </div>
                <span v-html="DATA.detail[lang]"></span>
              </div>
            </div>

            <div class="pic pic4 full" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene2/scene2-4.png${version}`" src="./assets/blank.png" />
            </div>
            <div class="info info4">
              <h5>{{ DATA.scene[1].head4[lang] }}</h5>
              <p v-html="DATA.scene[1].body4[lang]"></p>
            </div>

            <div class="gif">
              <div class="info5">
                <h5>{{ DATA.scene[1].head5[lang] }}</h5>
                <p v-html="DATA.scene[1].body5[lang]"></p>
              </div>
              <div class="pic5" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene2/scene2.gif${version}`" src="./assets/blank.png" />
              </div>
            </div>

            <section class="continue-box" @click="nextScene()">
              <div class="continue"></div>
            </section>
          </div>
        </div>

        <!-- 场景3 -->
        <div class="scene-box scene3" v-show="sceneID === 3" @scroll="stopVideo($event)">
          <div class="scroll">
            <div class="brief">
              <div class="num">{{ DATA.scene[sceneID - 1].id }}</div>
              <div class="inner" v-html="DATA.scene[sceneID - 1].brief[lang]"></div>
            </div>
            <div class="video-box">
              <!-- 高铁移动演播室第一段 -->
              <div class="video-cover" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene3/poster3_1.jpg${version}`" src="./assets/blank.png" />
                <div class="play" @click="createVideo('scene3-v1', pid3_1)"></div>
              </div>
              <div class="video-16-9" id="scene3-v1"></div>
            </div>
            <div class="info info1">
              <p v-html="DATA.scene[2].body1[lang]"></p>
            </div>
            <div class="pic pic1" v-lazy-container="{ selector: 'img' }">
              <img v-show="lang == 'zh'" :data-src="`${publicPath}img/scene3/scene3-1.png${version}`" src="./assets/blank.png" />
              <img v-show="lang == 'en'" :data-src="`${publicPath}img/scene3/scene3-1-en.png${version}`" src="./assets/blank.png" />
            </div>
            <div class="pic pic2 full" v-lazy-container="{ selector: 'img' }">
              <h5 v-html="DATA.scene[2].head2[lang]"></h5>
              <img :data-src="`${publicPath}img/scene3/scene3-2.png${version}`" src="./assets/blank.png" alt="高铁5G超高清演播室" />
            </div>
            <div class="info info2">
              <p v-html="DATA.scene[2].body3[lang]"></p>
              <div class="group" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene3/scene3-3.jpg${version}`" src="./assets/blank.png" alt="" class="i3" />
                <img :data-src="`${publicPath}img/scene3/scene3-4.jpg${version}`" src="./assets/blank.png" alt="" class="i4" />
              </div>
            </div>
            <div class="video-box">
              <!-- 记者体验5G列车隔空对话 -->
              <div class="video-cover" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene3/poster3_2.jpg${version}`" src="./assets/blank.png" />
                <div class="play" @click="createVideo('scene3-v2', pid3_2)"></div>
              </div>
              <div class="video-16-9" id="scene3-v2"></div>
            </div>
            <div class="gif" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene3/scene3.gif${version}`" src="./assets/blank.png" alt="" />
              <p v-html="DATA.scene[2].body4[lang]"></p>
            </div>
            <div class="pic pic3 full" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene3/scene3-5.png${version}`" src="./assets/blank.png" alt="京张高铁" />
            </div>

            <section class="continue-box" @click="nextScene()">
              <div class="continue"></div>
            </section>
          </div>
        </div>

        <!-- 场景4 -->
        <div class="scene-box scene4" v-show="sceneID === 4" @scroll="stopVideo($event)">
          <div class="scroll">
            <div class="brief">
              <div class="num" v-html="DATA.scene[3].id"></div>
              <div class="inner" v-html="DATA.scene[3].brief[lang]"></div>
            </div>

            <div class="pic pic1" v-lazy-container="{ selector: 'img' }">
              <img v-show="lang == 'zh'" :data-src="`${publicPath}img/scene4/scene4-1.jpg${version}`" src="./assets/blank.png" />
              <img v-show="lang == 'en'" :data-src="`${publicPath}img/scene4/scene4-1-en.jpg${version}`" src="./assets/blank.png" />
            </div>

            <div class="pic pic2" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene4/scene4-2.png${version}`" src="./assets/blank.png" />
            </div>

            <div class="info info1">
              <h5 v-html="DATA.scene[3].head1[lang]"></h5>
              <p v-html="DATA.scene[3].body1[lang]"></p>
            </div>

            <div class="pic pic3 full" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene4/scene4-3.png${version}`" src="./assets/blank.png" />
            </div>

            <div class="info info2">
              <h5 v-html="DATA.scene[3].head2[lang]"></h5>
              <p v-html="DATA.scene[3].body2[lang]"></p>
            </div>

            <div class="pic pic4" v-lazy-container="{ selector: 'img' }">
              <img v-show="lang == 'zh'" :data-src="`${publicPath}img/scene4/scene4-4.jpg${version}`" src="./assets/blank.png" />
              <img v-show="lang == 'en'" :data-src="`${publicPath}img/scene4/scene4-4-en.jpg${version}`" src="./assets/blank.png" />
            </div>

            <div class="pic pic5" v-lazy-container="{ selector: 'img' }">
              <img v-show="lang == 'zh'" :data-src="`${publicPath}img/scene4/scene4-5.jpg${version}`" src="./assets/blank.png" />
              <img v-show="lang == 'en'" :data-src="`${publicPath}img/scene4/scene4-5-en.jpg${version}`" src="./assets/blank.png" />
            </div>

            <div class="info info3">
              <h5 v-html="DATA.scene[3].head3[lang]"></h5>
              <p v-html="DATA.scene[3].body3[lang]"></p>
            </div>

            <div class="info info4">
              <h5 v-html="DATA.scene[3].head4[lang]"></h5>
              <p v-html="DATA.scene[3].body4[lang]"></p>
              <div class="pic6" v-lazy-container="{ selector: 'img' }">
                <img v-show="lang == 'zh'" :data-src="`${publicPath}img/scene4/scene4-6.png${version}`" src="./assets/blank.png" />
                <img v-show="lang == 'en'" :data-src="`${publicPath}img/scene4/scene4-6-en.png${version}`" src="./assets/blank.png" />
              </div>
            </div>

            <div class="pic pic7" v-lazy-container="{ selector: 'img' }">
              <img v-show="lang == 'zh'" :data-src="`${publicPath}img/scene4/scene4-7.png${version}`" src="./assets/blank.png" />
              <img v-show="lang == 'en'" :data-src="`${publicPath}img/scene4/scene4-7-en.png${version}`" src="./assets/blank.png" />
            </div>

            <div class="info info5">
              <h5 v-html="DATA.scene[3].head5[lang]"></h5>
              <p v-html="DATA.scene[3].body5[lang]"></p>
            </div>

            <section class="continue-box" @click="nextScene()">
              <div class="continue"></div>
            </section>
          </div>
        </div>

        <!-- 场景5 -->
        <div class="scene-box scene5" v-show="sceneID === 5" @scroll="stopVideo($event)">
          <div class="scroll">
            <div class="brief">
              <div class="num">{{ DATA.scene[4].id }}</div>
              <div class="inner" v-html="DATA.scene[4].brief[lang]"></div>
            </div>
            <!-- 融媒体支撑 -->
            <div class="video-box">
              <div class="video-cover" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene5/poster5_1.jpg${version}`" src="./assets/blank.png" />
                <div class="play" @click="createVideo('scene5-v1', pid5_1)"></div>
              </div>
              <div class="video-16-9" id="scene5-v1"></div>
            </div>

            <div class="pic pic1 full" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene5/scene5-1.jpg${version}`" src="./assets/blank.png" />
            </div>

            <div class="info info1">
              <h5>{{ DATA.scene[4].head1[lang] }}</h5>
              <p v-html="DATA.scene[4].body1[lang]"></p>
            </div>

            <!-- <div class="pic pic2" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene5/scene5-2.png`" src="./assets/blank.png" />
            </div>

            <div class="pic pic3" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene5/scene5-3.png`" src="./assets/blank.png" />
            </div> -->

            <div class="phone-live">
              <div class="pic pic4" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene5/scene5-4.png${version}`" src="./assets/blank.png" />
              </div>

              <div class="info info2">
                <h5>{{ DATA.scene[4].head2[lang] }}</h5>
                <p v-html="DATA.scene[4].body2[lang]"></p>
              </div>

              <div class="pic pic5" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene5/scene5-5.png${version}`" src="./assets/blank.png" />
              </div>

              <div class="info info6">
                <div>
                  <h5>{{ DATA.scene[4].head3[lang] }}</h5>
                  <p v-html="DATA.scene[4].body3[lang]"></p>
                </div>
                <div>
                  <h5>{{ DATA.scene[4].head4[lang] }}</h5>
                  <p v-html="DATA.scene[4].body4[lang]"></p>
                </div>
                <div>
                  <h5>{{ DATA.scene[4].head5[lang] }}</h5>
                  <p v-html="DATA.scene[4].body5[lang]"></p>
                </div>
                <div>
                  <h5>{{ DATA.scene[4].head6[lang] }}</h5>
                  <p v-html="DATA.scene[4].body6[lang]"></p>
                </div>
                <div>
                  <h5>{{ DATA.scene[4].head7[lang] }}</h5>
                  <p v-html="DATA.scene[4].body7[lang]"></p>
                </div>
              </div>
            </div>

            <div class="d3">
              <div class="phone">
                <div class="pic pic6" v-lazy-container="{ selector: 'img' }">
                  <img :data-src="`${publicPath}img/scene5/scene5-6.png${version}`" src="./assets/blank.png" />
                  <div class="title" v-html="DATA.scene[4].title1[lang]"></div>
                </div>

                <div class="pic pic7" v-lazy-container="{ selector: 'img' }">
                  <div class="title" v-html="DATA.scene[4].title2[lang]"></div>
                  <img :data-src="`${publicPath}img/scene5/scene5-7.png${version}`" src="./assets/blank.png" />
                </div>
              </div>

              <div class="info info7">
                <h5 v-html="DATA.scene[4].head8[lang]"></h5>
                <p v-html="DATA.scene[4].body8[lang]"></p>
              </div>
            </div>

            <div class="vr">
              <div class="pic8" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene5/scene5-8.png${version}`" src="./assets/blank.png" />
              </div>
              <div>
                <div class="pic9" v-lazy-container="{ selector: 'img' }">
                  <img :data-src="`${publicPath}img/scene5/scene5-9.jpg${version}`" src="./assets/blank.png" />
                </div>
                <div class="info info8">
                  <h5 v-html="DATA.scene[4].head9[lang]"></h5>
                  <p v-html="DATA.scene[4].body9[lang]"></p>
                </div>
              </div>
            </div>

            <div class="sc">
              <div>
                <div class="pic10" v-lazy-container="{ selector: 'img' }">
                  <img :data-src="`${publicPath}img/scene5/scene5-10.jpg${version}`" src="./assets/blank.png" />
                </div>
                <div class="info info9">
                  <h5 v-html="DATA.scene[4].head10[lang]"></h5>
                  <p v-html="DATA.scene[4].body10[lang]"></p>
                </div>
              </div>
              <div class="pic11" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene5/scene5-11.png${version}`" src="./assets/blank.png" />
              </div>
            </div>

            <div class="pic pic12" v-lazy-container="{ selector: 'img' }">
              <img :data-src="`${publicPath}img/scene5/scene5-12.jpg${version}`" src="./assets/blank.png" />
            </div>

            <!-- <section class="continue-box" @click="nextScene()">
              <div class="continue"></div>
            </section> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 高清转播车vr浮层 -->
    <van-popup v-model="popupCarVR" :closeable="true" class="vr-popup" :close-on-click-overlay="true" @close="closeCarVR">
      <div class="video-vr-box">
        <div class="video-vr" id="scene1-vr"></div>
      </div>
    </van-popup>

    <!-- 高清转播车介绍浮层 -->
    <van-popup v-model="popupCarIntro" :closeable="true" class="car-popup" :close-on-click-overlay="true">
      <div class="car-box">
        <div class="car-box-inner">
          <!-- <div class="car-control">
            <span class="up" @click="carIntroUp"></span>
            <span class="down" @click="carIntroDown"></span>
          </div> -->
          <div class="car-intro">
            <div class="car-scroll">
              <div class="car-img-float" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene1/popup1_1_1.jpg${version}`" src="./assets/blank.png" alt="" @click="preview(`${publicPath}img/scene1/popup1_1_1.jpg`)" />
                <img :data-src="`${publicPath}img/scene1/popup1_1_2.jpg${version}`" src="./assets/blank.png" alt="" @click="preview(`${publicPath}img/scene1/popup1_1_2.jpg`)" />
              </div>
              {{ DATA.scene[0].car_intro[lang] }}
              <div class="car-pic" v-lazy-container="{ selector: 'img' }">
                <img :data-src="`${publicPath}img/scene1/popup1_1_3.jpg${version}`" src="./assets/blank.png" alt="" @click="preview(`${publicPath}img/scene1/popup1_1_3.jpg`)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 场景2浮层 -->
    <van-popup v-model="showPopup" :closeable="true" class="popup2" :close-on-click-overlay="true">
      <div class="pop-box">
        <div class="pop-box-inner">
          <!-- <div class="pop-control">
            <span class="up" @click="popupIntroUp"></span>
            <span class="down" @click="popupIntroDown"></span>
          </div> -->
          <div class="pop-intro">
            <div class="pop-scroll">
              <div v-for="(item, index) in popupData" :key="index">
                <h5 v-html="item.head[lang]"></h5>
                <p v-html="item.body[lang]"></p>
                <!-- <div class="pop-pic" v-lazy-container="{ selector: 'img' }" v-for="(pic, idx) in item.pic" :key="idx">
                  <img :data-src="`${publicPath}${pic[lang]}`" src="./assets/blank.png" alt="" />
                </div> -->
                <div class="pop-pic" v-lazy-container="{ selector: 'img' }" v-for="(pic, idx) in item.pic" :key="idx" @click="preview(`${publicPath}${pic[lang]}${version}`)">
                  <img :data-src="`${publicPath}${pic[lang]}${version}`" src="./assets/blank.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 图片预览 -->
    <van-popup v-model="showPreview" class="preview-popup" :closeable="true" :close-on-click-overlay="true">
      <div class="preview-box">
        <img :src="previewImg" alt="" :style="`width:${previewScale * 100}%`" />
      </div>
      <div class="preview-stepper">
        <span @click="zoomout">+</span>
        <span>{{ previewScale }}</span>
        <span @click="zoomin">-</span>
        <span class="preview-reset" @click="previewReset"></span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import data from "./data.js";

import Vue from "vue";
// swiper
import "./css/swiper.min.css";
import Swiper from "swiper";
import { EffectFade } from "swiper";

// jquery
import $ from "jquery";
// gsap
import { gsap, Power0 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
// vue-lazyload
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {});
// vant
import { Popup } from "vant";
import "vant/lib/popup/style";
Vue.use(Popup);

// hammerjs
import Hammer from "hammerjs";

import "./css/landscape.scss";
import "./css/portrait.scss";
import "./css/_landscape_media.scss";
import "./css/_portrait_media.scss";

export default {
  data() {
    return {
      version: "?v=2022012605", // 防止public中图片缓存
      publicPath: process.env.BASE_URL,

      lang: "zh",
      angle: 0,
      DATA: data,
      swiper: null,

      timeline_swiper: [],

      sceneID: 1,

      popupCarIntro: false,
      popupCarVR: false,

      showPopup: false,
      popupData: [],

      showPreview: false,
      previewImg: "",
      previewScale: 1,
      previewStep: 0.5,
      previewMax: 5,
      previewMin: 1,

      activeVideo: false, // 是否创建过宣传片
      pid0: "d08cd87674ba46efbfc9bd70cccf8018", // 宣传片视频
      pid1_1: "3cb0faf89c414313b8790775eb5dc891", // 赛场呈现视频1
      pid1_closing: "4ce07404326647caa133a8de7cd7d327", //开闭幕式视频
      pid1_2: "84363856cd7a422c9d99e5af9b4c04e5", // 赛场呈现视频2
      pid2_1: "cc7f39d2985542d3a93f0b78cb1e5256", // 8k制播与公共服务
      pid3_1: "25ce480cc2724e428c88c085015fb7b0", // 高铁5G超高清演播室视频1
      pid3_2: "c6dcf41fa0454423a53f7d941be364df", // 高铁5G超高清演播室视频2
      pid5_1: "d8c895eb17ff48a3b304fe9ad7422f23", // 全媒体传播
      pidvr: "abbe844e9e244086ac4f52a9424ad4f6", // 8K超高清转播车VR
    };
  },
  created() {
    let that = this;

    that.angle = window.orientation || 0;
    window.addEventListener("orientationchange", that.handleOrientationchange, false);
    window.addEventListener("resize", that.handleOrientationchange, false);

    if (window.WeixinJSBridge) {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          console.log("weixin jsbridge ready");
          WeixinJSBridge.on("menu:setfont", function () {
            WeixinJSBridge.invoke("setFontSizeCallback", {
              fontSize: 0,
            });
          });
          that.init();
        },
        false
      );
    } else {
      window.addEventListener(
        "load",
        function () {
          console.log("window load");
          that.init();
        },
        false
      );
    }
  },
  mounted() {},

  methods: {
    init() {
      this.setSize();
      this.initSwiper();
      this.initSceneBg();
    },

    // 选择中英文
    chooseLang(lang) {
      this.lang = lang;
      if (this.swiper) {
        this.swiper.slideTo(1);
      }
    },

    setSize() {
      console.log("setsize");
      let longDis = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight;
      let shortDis = window.innerWidth < window.innerHeight ? window.innerWidth : window.innerHeight;
      $(".cmg-swiper").width(longDis).height(shortDis);
      $(".cmg-scene").width(longDis).height(shortDis);
    },

    slideTo(id) {
      if (this.swiper) {
        this.swiper.slideTo(id, 0);
      }
    },

    initSwiper() {
      let that = this;
      that.swiper = new Swiper("#cmg-swiper .swiper", {
        allowTouchMove: true,
        noSwiping: true,
        noSwipingClass: "swiper-no-swiping",
        preventClicks: false,
        modules: [EffectFade],
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },

        direction: "vertical",
        on: {
          init: function () {
            that.initSwiperTimeline();
          },
          activeIndexChange: function (swiper) {
            let index = swiper.activeIndex;
            that.timeline_swiper.forEach((tl, idx) => {
              if (idx === index) {
                that.timeline_swiper[idx].restart();
              } else {
                that.timeline_swiper[idx].reverse(-1);
              }
            });

            //let $video = $(".swiper-slide .content2").find("video");
            if (index !== 1) {
              //$video[0].pause();
              $(".swiper-slide .content2 .video-cover").show();
              $("#publicity-v").empty().removeAttr("originalstyle");
              $("#publicity-v").removeAttr("style");
            }
          },
        },
      });
    },

    // 场景背景滚动
    initSceneBg() {
      let that = this;
      let arr = [1, 2, 3, 4, 5];
      arr.forEach((i) => {
        that.aniSceneBg(i);
      });
    },

    aniSceneBg(id) {
      let $scene = $(".scene" + id);
      let $bg = $scene.find(".scroll");
      gsap.fromTo(
        $scene[0],
        { backgroundPositionX: 0 },
        {
          backgroundPositionX: "100%",
          scrollTrigger: {
            trigger: $bg[0],
            scroller: $scene[0],
            start: "left left",
            //end: "+=" + $bg.width(),
            end: "+=5800",
            horizontal: true,
            scrub: true,
          },
        }
      );
    },

    initSwiperTimeline() {
      let that = this;

      // tl1
      let snow1 = document.querySelector("#cmg-swiper .content1 .snow");
      let logo1 = document.querySelector("#cmg-swiper .content1 .cmg");
      let title1 = document.querySelector("#cmg-swiper .content1 .title");
      let lang = document.querySelector("#cmg-swiper  .lang");

      let tl1 = gsap.timeline({ paused: false });
      tl1.fromTo(snow1, { scale: 0, rotateZ: 90, opacity: 0 }, { scale: 1, rotateZ: 0, x: 0, opacity: 0.5, duration: 1 });
      tl1.fromTo(logo1, { x: -window.innerWidth, opacity: 1 }, { x: 0, opacity: 1, duration: 1.5 });
      tl1.fromTo(title1, { x: 10, opacity: 0 }, { x: 0, opacity: 1, duration: 1 }, "-=1");
      tl1.fromTo(lang, { x: -10, opacity: 0 }, { x: 0, opacity: 1, duration: 1 }, "-=1");

      that.timeline_swiper.push(tl1);

      // tl2
      let snow2 = document.querySelector("#cmg-swiper .content2 .snow");
      let logo2 = document.querySelector("#cmg-swiper .content2 .logo");
      let title2 = document.querySelector("#cmg-swiper .content2 .title");
      let brief = document.querySelector("#cmg-swiper  .content2 .brief");
      let video = document.querySelector("#cmg-swiper  .content2 .video-box");
      let prev = document.querySelector("#cmg-swiper  .content2 .prev");
      let next = document.querySelector("#cmg-swiper  .content2 .next");

      let tl2 = gsap.timeline({ paused: true });
      tl2.fromTo(logo2, { x: -10, opacity: 0 }, { x: 0, opacity: 1, duration: 1 });
      tl2.fromTo(snow2, { opacity: 0 }, { opacity: 1, duration: 0.5 }, "-=1");
      tl2.fromTo(title2, { x: 10, opacity: 0 }, { x: 0, opacity: 1, duration: 1 });
      tl2.fromTo(video, { x: -10, opacity: 0 }, { x: 0, opacity: 1, duration: 1 }, "-=1");
      tl2.fromTo(prev, { x: -10, opacity: 0 }, { x: 0, opacity: 1, duration: 1 }, "-=1");
      tl2.fromTo(next, { x: 10, opacity: 0 }, { x: 0, opacity: 1, duration: 1 }, "-=1");
      tl2.fromTo(brief, { x: 10, opacity: 0 }, { x: 0, opacity: 1, duration: 1 }, "-=1");
      that.timeline_swiper.push(tl2);

      // tl3
      let tl3 = gsap.timeline({ paused: true });

      let snow3 = document.querySelector("#cmg-swiper .content3 .snow");
      let logo3 = document.querySelector("#cmg-swiper .content3 .logo");
      let title3 = document.querySelector("#cmg-swiper .content3 .title");
      let menus = document.querySelectorAll("#cmg-swiper .content3 .menu-item");
      let prev3 = document.querySelector("#cmg-swiper  .content3 .prev");

      tl3.fromTo(logo3, { x: -10, opacity: 0 }, { x: 0, opacity: 1, duration: 1 });
      tl3.fromTo(snow3, { opacity: 0 }, { opacity: 1, duration: 0.5 }, "-=1");
      tl3.fromTo(title3, { x: 10, opacity: 0 }, { x: 0, opacity: 1, duration: 1 });
      tl3.fromTo(menus, { y: -10, opacity: 0 }, { y: 0, opacity: 1, duration: 1, stagger: 0.5 }, "-=1");
      tl3.fromTo(prev3, { opacity: 0 }, { opacity: 1, duration: 1 }, "-=1");

      that.timeline_swiper.push(tl3);
    },

    // 切换swiper方向
    swiperUpdateDirection() {
      let that = this;
      let angle = window.orientation;
      let swiperDirection = angle === 0 ? "vertical" : "horizontal";
      if (that.swiper) {
        that.swiper.changeDirection(swiperDirection, true);
        that.swiper.update();
      }
    },

    // 手机触发屏幕旋转
    handleOrientationchange() {
      let that = this;
      setTimeout(function () {
        that.setSize();
        that.swiperUpdateDirection();
      }, 200);
    },

    // 直接打开场景
    showScene(id) {
      let that = this;
      that.sceneID = id;
      $(".scene-box").scrollTop(0).scrollLeft(0);
      $(".cmg-scene").css({ opacity: 1 });
      $(`.scene${id}`).css({ opacity: 1 });
      $(".cmg-swiper").fadeOut();
    },

    // 返回
    hideScene() {
      $(".cmg-scene").css({ opacity: 0 });
      $(".cmg-swiper").fadeIn();
      this.swiperUpdateDirection();
      $(".scene-box").scrollTop(0).scrollLeft(0);

      // 暂停所有视频
      let $videos = $(".scene-box").find("video");
      if ($videos.length > 0) {
        $videos.each(function (index, video) {
          if (!video.paused) {
            video.pause();
          }
        });
      }
    },

    // 点击封面播放按钮，创建视频，只创建一次
    createVideo(id, pid, autoplay) {
      //let player = null;
      let auto = autoplay || "true";
      let playerParas = {
        divId: id,
        videoCenterId: pid,
        isAutoPlay: auto,
        playerType: "vod_h5",
      };

      // 创建成功 移动端无法触发
      // function playerReadyHandler(event) {
      //   event.target.removeEventListener("vodplayerready", playerReadyHandler);
      //   player = vodh5player.namespace.getVodPlayer();
      // }

      // 对播放器容器监听事件：vodplayerready，当播放器创建成功后触发
      let container = document.getElementById(id);
      //container.addEventListener("vodplayerready", playerReadyHandler);

      if (createVodPlayer) {
        createVodPlayer(playerParas);
      }

      let $videoCover = $(container).closest(".video-box").find(".video-cover");
      $videoCover.fadeOut();
    },

    createVRVideo(id, guid) {
      let l = window.innerWidth >= window.innerHeight ? window.innerWidth : window.innerHeight;
      let s = window.innerWidth < window.innerHeight ? window.innerWidth : window.innerHeight;
      let $v = $("#" + id);
      let w, h;
      if (l / s > 2) {
        w = s * 2;
        h = s;
      } else {
        w = l;
        h = l / 2;
        // $v.css({ top: "14%" });
      }

      $("#" + id)
        .width(w * 0.8)
        .height(w * 0.4);

      let playerParas = {
        divId: id, //必填。播放器容器id
        guid: guid, //必填。如果是点播，则为视频的guid，也可以直接填写视频地址，还可以填直播的频道名称
        title: "", //标题，可作为微信分享标题。如果为空，则从VDN获取标题
        msg: "", //简介，可作为微信分享简介
        image: "", //视频相关图片，可作为微信分享图片。如果不填，则为默认图片
        // w: $("#" + id).width(), //必填。播放器宽度
        // h: $("#" + id).height(), //必填。播放器高度
        w: w * 0.8,
        h: w * 0.4,
        vrType: "3", //vr类型，可以为1、2、3、4，默认是2。可以一个个试，画面不变形则为正确的值。
        playerType: "vod", //播放类型,比如live表示VR直播，vod表示VR点播
        mobileFullcreenType: "2", //移动端全屏类型，1表示保持原状，2表示只横向铺满屏幕，高度不变；3表示横向和竖向铺满屏幕
        isHttps: "true",
        fromApp: "cctvnews",
      };
      if (createVrPlayer) {
        createVrPlayer(playerParas);
      }
    },

    // 8k超高强转播车浮层介绍
    showCarIntro() {
      this.popupCarIntro = true;
    },

    // 8k超高强转播车浮层视频
    showCarVR() {
      let that = this;
      that.popupCarVR = true;
      // 8K超高清转播车VR
      that.$nextTick(function () {
        that.createVRVideo("scene1-vr", that.pidvr);
      });
    },

    closeCarVR() {
      $("#scene1-vr").empty();
    },

    carIntroUp() {
      let scrollHeight = $(".car-scroll").outerHeight();
      $(".car-scroll").animate({
        scrollTop: "+=" + scrollHeight / 2,
      });
    },

    carIntroDown() {
      let scrollHeight = $(".car-scroll").outerHeight();
      $(".car-scroll").animate({
        scrollTop: "-=" + scrollHeight / 2,
      });
    },

    showPopupIntro(data) {
      this.popupData = data;
      this.showPopup = true;
      this.$nextTick(function () {
        $(".pop-scroll").scrollTop(0);
      });
    },

    popupIntroUp() {
      let scrollHeight = $(".pop-scroll").outerHeight();
      $(".pop-scroll").animate({
        scrollTop: "+=" + scrollHeight / 2,
      });
    },

    popupIntroDown() {
      let scrollHeight = $(".pop-scroll").outerHeight();
      $(".pop-scroll").animate({
        scrollTop: "-=" + scrollHeight / 2,
      });
    },

    // 场景中切换下一个场景
    nextScene() {
      let that = this;
      let nextID = that.sceneID + 1;
      if (nextID > 5) {
        nextID = nextID % 5;
      }

      let tl = gsap.timeline();
      tl.fromTo(`.scene${that.sceneID}`, { opacity: 1 }, { opacity: 0, duration: 0.4 });
      tl.to(`.scene${that.sceneID}`, { scrollTop: 0, scrollLeft: 0, duration: 0 });
      tl.then(function () {
        that.sceneID = nextID;
        $(`.scene${that.sceneID}`).css({ opacity: 1 });

        $(`.scene${nextID}`).fadeIn(400, function () {});
      });
    },

    // 滚动停止视频播放
    stopVideo(e) {
      let $videos = $(e.target).find("video");
      if ($videos.length > 0) {
        //console.log(`有${$videos.length}个视频`);
        $videos.each(function (index, video) {
          let boundX = video.getBoundingClientRect().x;
          let boundY = video.getBoundingClientRect().y;
          let video_w = $(video).width() / 2;
          if ((boundX < 0 && Math.abs(boundX) > $(video).width() / 2) || (boundY < 0 && Math.abs(boundY) > video_w)) {
            if (!video.paused) {
              video.pause();
            }
          }
          let longDis = window.innerWidth > window.innerHeight ? window.innerWidth : window.innerHeight;
          if ((boundX > 0 && boundX > longDis) || (boundY > 0 && boundY > longDis)) {
            if (!video.paused) {
              video.pause();
            }
          }
        });
      }
    },

    preview(src) {
      let that = this;
      that.showPreview = true;
      that.previewImg = src;
      that.previewScale = 1;

      let lastX = 0;
      let lastY = 0;

      that.$nextTick(function () {
        let previewBox = $(".preview-box")[0];
        let img = $(".preview-box").find("img")[0];
        let hammer = new Hammer(previewBox, {});

        gsap.to(img, { x: 0, y: 0, duration: 0, ease: Power0.easeNone });

        hammer.on("pan", function (evt) {
          if (window.orientation === 0) {
            if (evt.deltaX > 0) {
              gsap.to(img, { y: lastY - evt.deltaX, duration: 0, ease: Power0.easeNone });
            }
            if (evt.deltaX < 0) {
              gsap.to(img, { y: lastY - evt.deltaX, duration: 0, ease: Power0.easeNone });
            }
            if (evt.deltaY > 0) {
              gsap.to(img, { x: lastX + evt.deltaY, duration: 0, ease: Power0.easeNone });
            }
            if (evt.deltaY < 0) {
              gsap.to(img, { x: lastX + evt.deltaY, duration: 0, ease: Power0.easeNone });
            }
          } else {
            gsap.to(img, { x: lastX + evt.deltaX, y: lastY + evt.deltaY, duration: 0, ease: Power0.easeNone });
          }
          console.log(evt);
        });

        hammer.on("panend", function (evt) {
          lastX = gsap.getProperty(img, "x");
          lastY = gsap.getProperty(img, "y");
        });
      });
    },

    zoomin() {
      if (this.previewScale > this.previewMin) {
        this.previewScale -= this.previewStep;
      }
    },
    zoomout() {
      if (this.previewScale < this.previewMax) {
        this.previewScale += this.previewStep;
      }
    },

    previewReset() {
      this.preview(this.previewImg);
    },
  },
};
</script>

<style></style>
